import { Row, Col } from "react-bootstrap";
import { useState } from "react";

const Subnav = (props) => {
  const [selectNav, setSelectNav] = useState(-1);

  const onNavSelect = (index) => {
    setSelectNav(index)
  }
  
  
  const { subnav } = props;
  return (
    <div className="m-3">
        <Row className="justify-content-start">
          <Col>
          <ul className="list-unstyled font-size-xs mb-0">
          {subnav.map((nav, index) => (
            <Row className="mb-1" key={index}>
            <Col md={1} sm={1} lg={1} xl={1} xs={1} className="align-content-center p-1" >
               <div className="d-flex justify-content-center my-auto" style={{width:"12px",height:"12px", borderRadius:"50%" , border:"1px solid #f66640"}}>
              <div className="my-auto" style={{width:"5px",height:"5px", borderRadius:"50%",backgroundColor: '#f66640' , opacity :  selectNav === index ? '1' : '0.4'}}>
                  
               </div>
               </div>
            </Col>
            <Col md={10} sm={10} lg={10} xl={10} xs={10}>
            <li className="mb-2" key={index} onClick={() => onNavSelect(index)}>
                  <div style={{ display: "flex" }}>
                    <div>
                      <a
                        className=""
                        href={`#${index + 1}`}
                        style={{ color: "black", textDecoration: "none" }}
                        data-scroll
                      >
                        <p
                          className="m-0"
                          style={{
                            textAlign: "left",
                            opacity: "0.7",
                            fontSize: "14px",
                          }}
                        >
                          {nav}
                        </p>
                      </a>
                    </div>
                  </div>
                </li>
            </Col>
            </Row>

          ))}
         </ul>
          </Col>
        </Row>

    </div>
  );
};

export default Subnav;
